(function ($) {
  'use strict';

  var SPEED = 300;

  function initFaqAccordion($scope) {
    ($scope || $(document)).find('.faq-accordion').each(function () {
      var $accordion = $(this);
      if ($accordion.data('faq-init')) return;
      $accordion.data('faq-init', true);

      var singleOpen =
        $accordion.data('single-open') === true || $accordion.data('single-open') === 'true';

      $accordion.find('.faq-accordion__item').each(function () {
        var $item = $(this);
        var $panel = $item.children('.accordion__content');

        if ($item.hasClass('accordion--open')) {
          $panel.show();
          $item.attr('open', '').attr('aria-expanded', 'true');
        } else {
          $panel.hide();
          $item.removeAttr('open').attr('aria-expanded', 'false');
        }
      });

      $accordion.on('click', '.faq-accordion__item > summary', function (e) {
        e.preventDefault();

        var $item = $(this).closest('.faq-accordion__item');
        var $panel = $item.children('.accordion__content');
        var isOpen = $item.hasClass('accordion--open');

        if (isOpen) {
          $panel.slideUp(SPEED, function () {
            $item.removeClass('accordion--open').removeAttr('open').attr('aria-expanded', 'false');
          });
          return;
        }

        if (singleOpen) {
          $accordion.find('.faq-accordion__item.accordion--open').each(function () {
            var $open = $(this);
            $open.children('.accordion__content').slideUp(SPEED);
            $open.removeClass('accordion--open').removeAttr('open').attr('aria-expanded', 'false');
          });
        }

        $item.addClass('accordion--open').attr('open', '').attr('aria-expanded', 'true');
        $panel.slideDown(SPEED);
      });
    });
  }

  $(function () {
    initFaqAccordion();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initFaqAccordion($(event.target));
  });
})(jQuery);
